import { render } from "./PowerStationInfo.vue?vue&type=template&id=0ddc8790"
import script from "./PowerStationInfo.vue?vue&type=script&lang=js"
export * from "./PowerStationInfo.vue?vue&type=script&lang=js"

import "./PowerStationInfo.vue?vue&type=style&index=0&id=0ddc8790&lang=scss"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__